import { CCStyling } from "../../cclib/CCStyling";
import { CCStructureItem } from "../../cclib/types/structure";
import {
  contributionGrid,
  deptEMForm,
  instructionsStyling,
  preamble,
  setIsMentorField
} from "../shared/structure";
const paragraphStyling = CCStyling.fromObject({
  "max-width": "1024px",
  "min-height": "7.5rem"
});

// Bottom of assistantStructure's definition has a .map()
// which sets isMentorField to this value.
const ALL_FIELDS_MENTOR = true;

export const assistantStructure: CCStructureItem[] = [
  ...preamble(
    "ANNUAL COUNSELING MEETING DOCUMENTATION FOR ASSISTANT AND ASSOCIATE PROFESSORS"
  ),
  {
    type: "date",
    key: "process_begin",
    name: "Date when process for faculty action (reappointment or promotion) will begin"
  },
  {
    type: "header",
    name: "Part 1"
  },

  {
    type: "header",
    name: "Overview"
  },
  {
    type: "instructions",
    additionalCss: instructionsStyling,
    text: "The core purpose of annual counseling is to provide candid and helpful feedback and guidance to the individual. Our goal is to provide a supportive atmosphere to assist our faculty in their academic careers. However, it should also be recognized that the ultimate responsibility for career trajectory and success lies with each faculty member himself or herself. Thus, it is up to the faculty member to respond to invitations to meet with their mentors or department chairs; to request such counseling and mentoring sessions if such sessions are not otherwise scheduled for them; to attend information sessions offered to them; and to be familiar with policies and procedures concerning reappointment and promotion, in particular, those included in the University and School faculty handbooks."
  },
  {
    type: "instructions",
    additionalCss: instructionsStyling,
    text: "University policy specifies that deans, department chairs, or their delegates should confer annually with each junior faculty member in their department or school to review his or her performance in the light of the criteria for reappointment or promotion. This form serves as documentation for the annual counseling meeting."
  },
  {
    type: "header",
    name: "Assessment of Progress toward Reappointment or Promotion"
  },
  {
    type: "instructions",
    additionalCss: instructionsStyling,
    text: "In advance of this annual counseling meeting, faculty member was provided with <u>a guide to Criteria, Review Process Steps, and Resources</u> aligned with next anticipated reappointment or promotion review."
  },
  {
    type: "check",
    key: "cv_was_reviewed",
    name: "The curriculum vitae for this faculty member was reviewed and discussed."
  },
  {
    type: "instructions",
    additionalCss: instructionsStyling,
    text: "With input from mentors or colleagues in the field, the following key points have been provided to the faculty member regarding progress toward reappointment or promotion in the following areas, including an assessment of the allocation of effort in each area:"
  },
  ...[
    ["Clinical activities", "clinical"],
    ["Scholarship activities", "scholarship"],
    ["Teaching activities", "teaching"],
    ["Administrative activities", "admin"],
    ["Allocation of time (including any planned leave)", "allocation"],
    ["Academic and professional support", "academic"],
    ["Availability of mentors", "avail_mentors"],
    ["Availability of resources", "avail_resources"],
    ["Opportunities for learning", "opp"],
    ["Quality improvement projects", "quality"],
    ["Advocacy activities", "advocacy"],
    ["Mentorship activities", "mentorship"],
    ["Financial issues", "financial"],
    ["Professional Development", "professional"],
    ["Achievement of career goals", "achievement"],
    ["Criteria and timeline for reappointment or promotion", "criteria"],
    ["Personal issues (if applicable)", "personal"],
    ["Professionalism and collegiality", "professionalism"],
    ["Other topics (please describe)", "other"]
  ].map(([title, topic]) => {
    return {
      type: "check",
      name: title,
      key: `topic_${topic}`,
      optional: true
    };
  }),
  {
    type: "paragraph",
    key: "other_topics_describe",
    optional: true,
    additionalCss: paragraphStyling
  },
  {
    type: "paragraph",
    key: "following_matters_important",
    text: "<strong>The following matters were identified by me as important in the FACULTY MEMBER'S DEVELOPMENT over the next year</strong> (with input from the faculty member's mentor or colleagues in his/her field):"
  },
  {
    type: "paragraph",
    key: "counsel_provided",
    text: "<strong>I have provided the following COUNSEL REGARDING CAREER PLANNING AND GOALS for the next year?</strong> (with input from the faculty member's mentor or colleagues in his/her field):"
  },
  {
    type: "check",
    key: "confirm_discussion",
    name: "I confirm that I have discussed progress toward reappointment/promotion with the faculty member."
  },
  {
    type: "header",
    name: "Current and Anticipated Proportionality of Contribution"
  },
  ...contributionGrid(),
  {
    type: "paragraph",
    text: "Other, if applicable (specify):",
    key: "contrib_other_paragraph",
    optional: true
  },
  ...deptEMForm(true)
].map((item: CCStructureItem) => setIsMentorField(item, ALL_FIELDS_MENTOR));
